import { mount } from "svelte";
import AiSearchButton from "../pages/Search/components/PeopleSearchBar/AiSearchButton.svelte";

export const bindAiSearchButton = () => {
  const target = document.getElementsByClassName(
    "ai-search-button-container",
  )[0];
  if (target) {
    return mount(AiSearchButton, { target });
  }
};
